
import { defineComponent, watch, ref } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "card-3",
  components: {},
  props: {
    cardClasses: String,

    avatar: String,

    online: Boolean,

    initials: String,

    color: String,

    name: String,

    jobTitle: String,

    avgEarnings: String,

    totalSales: String,

    connected: Boolean,

    profilePicture: String,

    linkedInProfile: String,

    introduction: String,

    expertId: String,

    isAlreadyConnected: Boolean,

    fromConnectedExperts: Boolean,

    founderRequisiteExpertsMain: Array,

    expertRequisiteConnectionStatus: Object,

    selectedExpertise: Object,
  },
  setup(props) {
    const loading = ref<boolean>(false);
    const store = useStore();
    const isConnected = ref<boolean>(props.isAlreadyConnected);
    const founderRequisiteExperts = ref<Array<Record<string, unknown>>>([]);
    watch(
      () => props.isAlreadyConnected,
      (value) => (isConnected.value = value)
    );
    const truncateText = (text, limit) => {
      return (text ?? "")?.substr(0,limit) + (text.length > 30 ? "..." : "")
    }
    const attachExpert = async () => {
      loading.value = true;
      try {
        const response = await store.dispatch(
          Actions.FOUNDER_REQUISITE_EXPERT,
          {
            expertId: props.expertId,
            expertiseIds: props?.selectedExpertise ?? [],
          }
        );
        if (response !== true) throw new Error();
        store.dispatch(Actions.AUTH_USER);
        loading.value = false;
        store.commit("setAlert", {
          message: "Success",
          subMessage: "A Request has been sent to the expert",
          variant: "primary",
          duration: 4000,
          show: true,
        });
      } catch (err) {
        loading.value = false;
        store.commit("setAlert", {
          message: "Error",
          subMessage:
            "Sorry, looks like there are some errors detected, please try again.",
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    return {
      truncateText,
      loading,
      attachExpert,
      isConnected,
      founderRequisiteExperts,
    };
  },
});
